import {
  Button,
  DialogActions,
  DialogContent,
  HexIcon,
  ExternalLink,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { AssignCredentialsDialogHeader } from '../../../_components/AssignCredentialsDialogHeader';

import { EXTERNAL_LINKS } from '@cast/constants';

type Props = {
  onClose: () => void;
};

export const SuccessSlide = ({ onClose }: Props) => {
  return (
    <Stack position="relative">
      <AssignCredentialsDialogHeader dismiss={onClose} />
      <DialogContent>
        <Stack gap={12} mb={16}>
          <Stack direction="row" alignItems="center" gap={8}>
            <HexIcon variant="success" size={40} />
            <Typography variant="h6">
              Successfully enabled GPU metrics
            </Typography>
          </Stack>
          <Typography variant="P12R" color="textSecondary">
            GPU metrics monitoring is now enabled! Start exploring the powerful
            monitoring dashboard.{' '}
            <ExternalLink
              sx={{ typography: 'P12R' }}
              link={EXTERNAL_LINKS.aws_console}
            >
              Documentation
            </ExternalLink>
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{ py: 16, borderTop: tokens.theme.border.structural.neutralSubtle }}
      >
        <Button onClick={onClose} variant="primary">
          Done
        </Button>
      </DialogActions>
    </Stack>
  );
};
